/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RegisterRequest { 
    name: string;
    lastName: string;
    userName: string;
    emailAddress: string;
    password: string;
}

